import styled, { createGlobalStyle } from 'styled-components'
import Responsive from '../config/Responsive'
import Colors from './Colors'

const GlobalStyle = createGlobalStyle`

`

// hide scroll bar all screen size
export const Scrollbar = createGlobalStyle<{ hideScroll: boolean }>`
  body {
      overflow: ${(props) => (props.hideScroll === true ? 'hidden' : 'unset')};
      padding-right: ${(props) => (props.hideScroll === true ? '5px' : '0px')};
  }
`
// hide scroll bar in mobile
export const ScrollbarInMobile = createGlobalStyle<{ hideScroll: boolean }>`
  body {
    ${Responsive.mobile}{
      overflow: ${(props) => (props.hideScroll === true ? 'hidden' : 'unset')};
      padding-right: ${(props) => (props.hideScroll === true ? '5px' : '0px')};
    }
  }
`

// full screen
export const FullScreen = styled.div`
  min-height: calc(100vh - 56px);
  padding: 50px 0px;
`

// large page title
export const MediumScreenTitle = styled.h5`
  border-left: 2px solid ${Colors.primaryGrey};
  padding: 0px 5px 5px 5px;
  width: fit-content;
  margin-bottom: 50px;
  color: ${Colors.primaryGrey};
`

// containers
export const Container = styled.div`
  width: 100%;
  margin-inline: auto;
  max-width: 1526px;

  ${Responsive.desktop} {
    max-width: 1526px;
  }
  ${Responsive.laptop} {
    max-width: 1104px;
  }
  ${Responsive.tablet} {
    max-width: 760px;
  }
  ${Responsive.mobile} {
    max-width: 600px;
    padding-inline: 20px;
  }
`
export const LargeContainer = styled.div`
  width: 100%;
  margin-inline: auto;
  max-width: 1600px;

  ${Responsive.laptop} {
    max-width: 1520px;
    padding-inline: 40px;
  }
  ${Responsive.tablet} {
    max-width: 1120px;
    padding-inline: 40px;
  }
  ${Responsive.mobile} {
    padding-inline: 20px;
  }
`

export default GlobalStyle
